import styled from "styled-components";

export default function DenyOrderNotice({ textList }) {
  return (
    <NoticeBlock>
      {textList.map((text, index) =>
        <NoticeParagraph key={`notice_${index}`}>{text}</NoticeParagraph>
      )}
    </NoticeBlock>
  )
}

const NoticeBlock = styled.div`
  background-color: #F7F7F7;
  width: 100%;
  padding-top: calc(100vw * (17 / 375));
  padding-bottom: calc(100vw * (17 / 375));
  padding-right: calc(100vw * (12 / 375));
  padding-left: calc(100vw * (33 / 375));
  border-radius: calc(100vw * (5 / 375));
`;

const NoticeParagraph = styled.p`
  position: relative;
  font-size: calc(100vw * (12 / 375));
  font-weight: 500;
  line-height: calc(100vw * (16.92 / 375));
  white-space: pre-wrap;
  color: #7F7F7F;

  &::after {
    content: "✔️";
    position: absolute;
    top: 0;
    left: calc(100vw * (-16 / 375));
    font-size: calc(100vw * (9 / 375));
  }
`;